import React, { Component } from "react";
import firebase from "../Firebase/Firebase";
import "./CreateRequest.css";

class CreateRequest extends Component {
  constructor() {
    super();

    this.state = {
      phoneNumber: "",
      name: "",
      amount: "",
      description: "",
      errors: {
        amount: false,
        amountTooLow: false,
        amountTooHigh: false
      },
      isSubmitTriggered: false
    };

    this.descriptionMaxLength = 30;

    this.handleChange = this.handleChange.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.createRequest = this.createRequest.bind(this);
  }

  componentDidMount() {
    const phoneNumber = localStorage.getItem("phoneNumber");
    const name = localStorage.getItem("tag");

    this.setState({ phoneNumber, name });
  }

  handleChange(event) {
    const target = event.target;

    // don't allow description more than X characters
    if (
      target.name === "description" &&
      target.value.length > this.descriptionMaxLength
    ) {
      return false;
    }

    this.setState(
      {
        [target.name]: target.value
      },
      () => {
        if (this.state.isSubmitTriggered) {
          this.validateForm();
        }
      }
    );
  }

  validateForm(onValidForm) {
    const amount = parseInt(this.state.amount, 10);
    const description = this.state.description;

    const errors = {
      amount: !amount,
      amountTooLow: !!amount && amount < 0,
      description: !description
    };

    this.setState({ errors });

    const errorKeys = Object.keys(errors).filter(key => errors[key]);

    // invoke callback function when form has no errors
    if (onValidForm && errorKeys.length === 0) {
      onValidForm();
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ isSubmitTriggered: true });

    this.validateForm(this.createRequest);
  }

  createRequest() {
    const item = {
      name: this.state.name,
      phoneNumber: this.state.phoneNumber,
      amount: parseInt(this.state.amount, 10),
      description: this.state.description,
      createdAt: new Date().toISOString()
    };

    const itemRef = firebase
      .database()
      .ref("requests")
      .push(item, error => {
        if (error) {
          console.log(error);
        } else {
          this.props.history.push(`solicitar/${itemRef.key}`);
        }
      });
  }

  getDescriptionCharsLeft() {
    return this.descriptionMaxLength - this.state.description.length;
  }

  render() {
    const { amount, description, errors } = this.state;

    return (
      <form className="create-request" action="" onSubmit={this.handleSubmit}>
        <h1>Solicitar dinero</h1>
        <div className="create-request-input-group">
          <div className="create-request-input-group">
            <label className="create-request-label-amount" htmlFor="amount">
              Monto a solicitar
            </label>
            <div className="create-request-amount-input-group">
              <span className="create-request-input-amount-prefix">COP</span>
              <input
                className="create-request-input-amount"
                id="amount"
                name="amount"
                type="number"
                pattern="[0-9]*"
                placeholder="0"
                value={amount}
                onChange={this.handleChange}
                aria-invalid={errors.amount}
                autoComplete="off"
              />
            </div>
          </div>
          {errors.amount && (
            <div className="create-request-input-error" aria-live="polite">
              Ingrese una monto válida
            </div>
          )}
          {errors.amountTooLow && (
            <div className="create-request-input-error" aria-live="polite">
              Ingrese un monto superior a 0
            </div>
          )}
        </div>
        <div className="create-request-input-group">
          <label
            className="create-request-label-description"
            htmlFor="description"
          >
            Descripción
          </label>
          <div className="create-request-characters-left">
            Quedan {this.getDescriptionCharsLeft()} caracteres
          </div>
          <textarea
            className="create-request-input-description"
            id="description"
            name="description"
            value={description}
            onChange={this.handleChange}
          />
        </div>
        {errors.description && (
          <div className="create-request-input-error" aria-live="polite">
            Ingrese un descripción
          </div>
        )}
        <button
          className="create-request-submit button-green"
          onClick={this.handleSubmit}
        >
          Crear solicitud de dinero
        </button>
      </form>
    );
  }
}

export default CreateRequest;



// WEBPACK FOOTER //
// ./src/CreateRequest/CreateRequest.js